import React from 'react';
import './Contact.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          {/* <div className="section-badge">
            <span>Get In Touch</span>
          </div> */}
          <h1 className="section-title">
            Let's Build Something <span className="highlight-text">Amazing Together</span>
          </h1>
          <p className="section-description">
            Ready to transform your ideas into exceptional digital experiences? 
            I'm always excited to discuss new opportunities and innovative projects.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Info Cards */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="info-content">
                <h3>Email</h3>
                <p>dawitendaylalu@gmail.com</p>
              </div>
            </div>
            
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <div className="info-content">
                <h3>Location</h3>
                <p>New York City, NY</p>
              </div>
            </div>
            
            <div className="info-card">
              <div className="info-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <div className="info-content">
                <h3>Let's Connect</h3>
                <p>Available for opportunities</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="form-container">
            <form
              action="https://getform.io/f/049dc321-e767-41dd-847b-66fba12939ed"
              method="POST"
              className="contact-form"
            >
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    className="form-input"
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Your full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    className="form-input"
                    type="email"
                    name="email"
                    id="email"
                    placeholder="your.email@example.com"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  className="form-input"
                  type="text"
                  name="subject"
                  id="subject"
                  placeholder="Project collaboration, job opportunity, etc."
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  className="form-input"
                  name="message"
                  id="message"
                  placeholder="Tell me about your project or opportunity..."
                  rows="5"
                  required
                ></textarea>
              </div>

              <button className="submit-button" type="submit">
                <span>Send Message</span>
                <FontAwesomeIcon icon={faEnvelope} />
              </button>
            </form>
          </div>
        </div>

        {/* Social Links */}
        <div className="social-section">
          <h3>Connect With Me</h3>
          <div className="social-links">
            <a href="https://www.linkedin.com/in/dawit-endaylalu/" className="social-link linkedin" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} />
              <span>LinkedIn</span>
            </a>
            <a href="https://github.com/dawit-design" className="social-link github" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGithub} />
              <span>GitHub</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
